import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  /*** SCROLLBAR ***/
  ::-webkit-scrollbar {
    width: 16px;
  }
  ::-webkit-scrollbar-track {
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #9f9f9f;
    border-radius: 10px;
    border: 4px solid #ffffff;
  }

  body {
    font-family: sans-serif;
    margin: 0px;
    padding: 0px;
    background-color: #ffffff;
  }

  h1{
    font-family: cursive;
    font-weight: 600;
    font-size: 43px;
    margin: 0px;
    padding: 0px;
  }

  p{
    font-size: 15px;
    font-weight: normal;
    color: #424242;
    line-height: 25px;
  }

`;

export default GlobalStyles;
